import {defineStore} from 'pinia';
import {DataService} from '../../api';

export const usePluginStore = defineStore('plugin', {
  state: () => ({
    plugins: [],
    menuItems: [],
    panels: {},
  }),

  getters: {
    pluginList: (state) => state.plugins,
    sidebarMenuItems: (state) => state.menuItems,
    pluginPanels: (state) => state.panels
  },

  actions: {
    async initPluginStore() {
      this.initPlugins();
    },

    initPlugins() {
      DataService.read('config', {
        attributes: 'value',
        filters: {label: 'eq.custom.plugins.load'},
      }).then((res) => {
        if (res?.data && res?.data.length > 0) {
          this.plugins = res.data[0].value;
          this.generateMenuItemsList(this.plugins);
          this.generatePanels(this.plugins);
        }
      });
    },

    async generateMenuItemsList(pluginList) {
      let menuItems = [];
      for (const plugin of pluginList) {
        try {
          const {default: getMenuItems} = await import(
            `@plugins/${plugin}-webui/config/menu`
            );
          menuItems = menuItems.concat(getMenuItems());
        } catch (error) {
          console.error(`Error loading menu for plugin: ${plugin}`, error);
        }
      }
      this.menuItems = menuItems;
    },

    async generatePanels(pluginList) {
      let panels = {};
      for (const plugin of pluginList) {
        try {
          const { default: getPanels } = await import(`@plugins/${plugin}-webui/config/panel`);
          const pluginPanels = getPanels();
          for (const panel of pluginPanels) {
            if (!(panel?.target in panels)) {
              panels[panel.target] = [];
            }
            const resolvedPanel = {
              ...panel,
              panel: (await panel.panel()).default,
            };
            panels[panel.target].push(resolvedPanel);
          }
        } catch (error) {
          console.error(`Error generating panels for plugin: ${plugin}`, error);
        }
      }
      this.panels = panels;
    },

    getViewPanels (viewName) {
      return this.panels?.[viewName] ?? [];
    }
  },
});